import React, {useEffect, useState } from 'react';
import { connect } from "react-redux";

import { getItem } from '@craftercms/content';
import { httpGet, crafterConf } from "@craftercms/classes";
import { composeUrl } from "@craftercms/utils";

import { Link } from 'react-router-dom';
import { languagePicker, getLabel, getNewUrl, removeIgnoreItems} from '../../utils';

import history from '../../history';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBars, faTimes, faSearch , faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import SearchBar from '../SearchBar/SearchBar';
import SideMenu from '../SideMenu/SideMenu';
import LiveBar from '../LiveBar/LiveBar';

import HeaderHolder from './HeaderStyles';

const Header = (props) => {
  const [altImage, setAltImage] = useState();
  const [logoSrc, setLogoSrc] = useState();
  const [helpUrl, setHelpUrl] = useState();
  const [navigation, setNavigation] = useState([]);
  const [socialMedia, setSocialMedia] = useState([]);
  const [sideMenuItems, setSideMenuItems] = useState([]);
  const [liveStreams, setLiveStreams] = useState([]);

  const [searchBarActive, setSearchBarActive] = useState(false);
  const [sideMenuActive, setSideMenuActive] = useState(false);
  const [liveBarActive, setLiveBarActive] = useState(false);
  const [backDropActive, setBackDropActive] = useState(false);
  const [languageActive, setLanguageActive] = useState("");

  useEffect(()=> {
    document.addEventListener('click', handleClickOutside, true);
    return ()=> {
      document.removeEventListener('click', handleClickOutside);
    }
  },[]);

  useEffect(() => { 
    getItem("/site/components/common/header.xml").subscribe((item) => {

    if (item) {
          languagePicker(item, ["alt_image_s", "hamburgerMenuLinksRG_o.label_s", "hamburgerMenuLinksRG_o.url_s", 
          "socialMediaLinksRG_o.alt_image_s", "navigationMenuLinksRG_o.label_s", "navigationMenuLinksRG_o.url_s",
          "breakingNewsRG_o.news_text_s","breakingNewsRG_o.livestream_flag_s","breakingNewsRG_o.url_s","help_url_s"]);
          setAltImage(item.descriptorDom.component.alt_image);
          setLogoSrc(item.descriptorDom.component.logo_s);
          setNavigation(item.descriptorDom.component.navigationMenuLinksRG_o.item);
          props.setBreakingNews(item.descriptorDom.component.breakingNewsRG_o.item);
          setSocialMedia(item.descriptorDom.component.socialMediaLinksRG_o.item);
          setSideMenuItems(item.descriptorDom.component.hamburgerMenuLinksRG_o.item);
          setHelpUrl(item.descriptorDom.component.help_url);
      }
    });

    const craftConf = crafterConf.getConfig();
		const serviceUrl = composeUrl(craftConf , process.env.REACT_APP_LIVESTREAMS_ENDPOINT);

    httpGet(serviceUrl, {url:"/site/website/home/index.xml", crafterSite:craftConf.site}).subscribe(data => {
      if (data) {
        languagePicker(data, ["itemList.title_t","itemList.description_t","itemList.image_s","itemList.altImageTxt_s","itemList.category_t","itemList.categoryURL_s","itemList.url_s"])
        const dataHeader = data.component.itemList? removeIgnoreItems(data.component.itemList): [];
        setLiveStreams(dataHeader);
      }
    });

    if(props.current_lang === "en") {
      setLanguageActive("en");
    } else {
       setLanguageActive("fr");
    }
    document.documentElement.lang = props.current_lang;
  },[props.current_lang]);

  useEffect(()=> {
    props.setBackdrop(backDropActive);
  },[backDropActive]);

const renderNavLinks = () => {
  return navigation.map((it, i) => {
    if(it.label !== "Live" && it.label !== "En direct") {
      return (
        <Link key={`main-nav-${i}`} to={it.url}>
          <img src={it.icon} alt={`${it.label} icon`}/>{it.label}
          {it.separator_b === "true" && <div className="r-separator"></div>}
        </Link>
      );
    } else {
      return (
        <a 
          key={`main-nav-${i}`}
          onClick={(e)=>{liveBarClickHandler(e)}}
          onKeyDown={(e) => handleKeyPress(e, liveBarClickHandler)}
          className="live-counter"
          tabIndex="0"
          id="liveBarClickHandler"
        >
          {liveStreams && <div className="live-counter__ico">{liveStreams.length}</div>}
          <img src={it.icon} alt={`${it.label} icon`}/> {it.label}
          {it.separator_b === "true" && <div className="r-separator"></div>}
        </a>
      )
    }
  });
};

const languageClickHandler = () => {
    const newUrl = getNewUrl(props.urlMap, window.location.pathname, window.location.search, props.current_lang);
    let language = "en";

    if (languageActive === "en") {
        language = "fr";
    }

    if(window.location.pathname !== "/") {
      history.push(newUrl);
    }
  
    setLanguageActive(language);
    props.setCurrentLanguage(language);  
}

const renderSocialMediaLinks = () => {
  return socialMedia.map((it, i) => {
    return (
      <a href={it.url} key={`social-nav-${i}`} target="_blank" rel="noreferrer">
        <img src={it.image} alt={it.alt_image}/>
      </a>
    )
  });
};

const hambClickHandler = () => {
  sideMenuActive ? setSideMenuActive(false) : setSideMenuActive(true);
  sessionStorage.getItem('currentModalElement') && document.querySelectorAll(`#${sessionStorage.getItem('currentModalElement')}`)[0].focus();

  if(searchBarActive || liveBarActive) {
    setSearchBarActive(false);
    setLiveBarActive(false);
  }
  if(sideMenuActive) {
    setBackDropActive(false);
  } else {
    setBackDropActive(true);
  }
}

const searchClickHandler = () => {
  searchBarActive ? setSearchBarActive(false) : setSearchBarActive(true);
  sessionStorage.getItem('currentModalElement') && document.querySelectorAll(`#${sessionStorage.getItem('currentModalElement')}`)[0].focus();

  if(sideMenuActive || liveBarActive) {
    setSideMenuActive(false);
    setLiveBarActive(false);
  }
  if(searchBarActive) {
    setBackDropActive(false);
  } else {
    setBackDropActive(true);
  }
}

const liveBarClickHandler = (e) => {
  e && e.preventDefault();
  sessionStorage.getItem('currentModalElement') && document.querySelectorAll(`#${sessionStorage.getItem('currentModalElement')}`)[0].focus();
  liveBarActive ? setLiveBarActive(false) : setLiveBarActive(true);

  if(searchBarActive || sideMenuActive) {
    setSearchBarActive(false);
    setSideMenuActive(false);
  }
  if(liveBarActive) {
    setBackDropActive(false);
  } else {
    setBackDropActive(true);
  }

}

const handleClickOutside = e => {
  if (e.target.tagName === "DIV" || e.target.tagName === "NAV" || e.target.tagName === "SPAN") {
      hideAll();
  }
}
const handleMenuClick = () => {
  hambClickHandler();
  setTimeout(() => {
    document
      .querySelectorAll('.side-menu a')[0].focus();
  }, 300);
}
const handleKeyPress = (e, action) => {
  if(e.key === 'Enter'){
    sessionStorage.setItem('currentModalElement', e.target.id);
    action(e);
  }
}
const handleEscape = (e, action) => {
  if (e.key === "Escape") {
    action();
    document.removeEventListener("keydown", action());
  }
};

const hideAll = () => {
  setSideMenuActive(false);
  setSearchBarActive(false);
  setLiveBarActive(false);
  setBackDropActive(false);
}

return (
    <HeaderHolder>
      <meta itemProp="author" content={`${props.current_lang === "en" ? "CPAC - Cable Public Affairs Channel" : "CPAC - la chaîne d'affaires publiques par câble" }`} />
      <meta itemScope itemType="https://schema.org/Organization" />
      <meta itemProp="name" content={`${props.current_lang === "en" ? "CPAC - Cable Public Affairs Channel" : "CPAC - la chaîne d'affaires publiques par câble" }`} />
      <div className="header" itemScope itemType='https://schema.org/WPHeader'> 
        <hgroup className="header__brand-nav" itemScope itemType='https://schema.org/Brand'>
          <div
            tabIndex="0"
            aria-label="menu icon"
            className={`header__brand-nav__hamb-menu ${sideMenuActive ? "inverted" : "" }`}
            onClick={hambClickHandler}
            onKeyDown={(e) => handleKeyPress(e, handleMenuClick)}
            role="button"
            id="hambClickHandler"
          >
            <FontAwesomeIcon icon={(sideMenuActive ? faTimes : faBars)}/>
          </div>
          <Link to={"/"} className={`header__brand-nav__logo ${sideMenuActive ? "inverted" : "" }`}>
            <img src={logoSrc} alt={altImage} itemProp='logo' />
          </Link>
          <Link to={"/"}><span className={`${sideMenuActive ? "inverted ham-home" : "" }`}>{getLabel("HOME")}</span></Link>
        </hgroup>
        <nav className="header__main-nav" itemProp='mainEntity' itemScope itemType='https://schema.org/SiteNavigationElement'>
          {renderNavLinks()}
        </nav>
        <hgroup className="header__multi">
          <div
            className="header__multi__language-p"
            onClick={()=>languageClickHandler()}
            onKeyDown={(e) => handleKeyPress(e, languageClickHandler)}
            tabIndex="0"
            role="button"
            id="languageClickHandler"
          >
            <span>{getLabel("LANGUAGEPICKER")}</span>
          </div>
          <div className="header__multi__social">
            {renderSocialMediaLinks()}
          </div>
          <div className="header__multi__search">
            <span
              tabIndex="0"
              aria-label={getLabel("SEARCH")}
              onKeyDown={(e) => handleKeyPress(e, searchClickHandler)}
              onClick={searchClickHandler}
              role="button"
              id="searchClickHandler"
            >
              <FontAwesomeIcon icon={(searchBarActive ? faTimes : faSearch)} title="search"/>
            </span>
            {helpUrl && <Link to={helpUrl}><FontAwesomeIcon icon={faQuestionCircle} title="help"/><span className="screen-reader-text">Help</span></Link>}
          </div>
        </hgroup>
      </div>
      {liveStreams &&
        <LiveBar
          active={liveBarActive}
          livestreams={liveStreams}
          liveBarClickHandler={liveBarClickHandler}
          handleEscape={handleEscape}
          setActive={()=>hideAll()}
        />
      }
      <SearchBar
        active={searchBarActive}
        searchClickHandler={searchClickHandler}
        handleEscape={handleEscape}
      /> 
      <SideMenu
        active={sideMenuActive}
        links={sideMenuItems}
        socialMedia={ socialMedia }
        mainNavLinks={navigation}
        hambClickHandler={hambClickHandler}
        handleEscape={handleEscape}
        setActive={()=>hideAll()}
      /> 
    </HeaderHolder>
  )

}
const mapStateToProps = (store) => ({
    current_lang: store.language.current,
    urlMap: store.urlMap
});

const mapDispatchToProps = (dispatch) => ({
  setBackdrop: (backDropActive) => dispatch({ type: 'SET_BACKDROP', active: backDropActive }),
  setCurrentLanguage: (languageActive) => dispatch({ type: 'SET_CUR_LANG', current: languageActive }),
  setBreakingNews: (breakingNews) => dispatch({ type: "SET_BR_NEWS", news: breakingNews})
});

export default connect(mapStateToProps,mapDispatchToProps)(Header);